var map = {
	"./image-1.jpg": 9313,
	"./image-2.jpg": 7894,
	"./image-3.jpg": 67,
	"./image-4.jpg": 8416,
	"./image-5.jpg": 9341,
	"./image-6.png": 1286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3880;